import { Directive, ElementRef, forwardRef, HostListener, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { Keys } from '@skylab-shared/ui';

import { EventBus, EventBusBase } from '@skylab-angular-shared/core';

import { ValueAccessor } from './value-accessor';

@Directive({
    selector: 'ins-input:not([inputmode=decimal])',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextValueAccessorDirective),
            multi: true,
        },
    ]
})
export class TextValueAccessorDirective extends ValueAccessor {

    public constructor(
        elm: ElementRef,
        @Inject(EventBus) eventBus: EventBusBase
    ) {
        super(elm, eventBus);
    }

    public override ngAfterViewInit(): void {
        super.ngAfterViewInit();
        this.element.getInputElement().then(elm => {
            elm?.setSelectionRange(0, elm?.value?.length ?? 0, 'backward');
        });
    }

    public override registerOnChange(fn: (value: any) => void): void {
        super.registerOnChange(value => {
            fn(value);
        });
    }

    public override registerOnTouched(fn: () => void): void {
        super.registerOnTouched(() => {
            fn();
        });
    }

    @HostListener('keyup', ['$event'])
    protected handleEnter(event: KeyboardEvent): void {
        if (event.keyCode === Keys.Enter) {
            this.handleBlurEvent(event.target as HTMLInputElement);
        }
    }

    @HostListener('insBlur', ['$event.target'])
    protected override handleBlurEvent(elm: unknown): void {
        if (elm === this.elm.nativeElement) {
            this.handleChangeEvent(elm as HTMLInputElement, (elm as HTMLInputElement).value);
            this.onTouched();
        }
    }
}
